import FormType from "../../../../../../Components/Form/FormType";
import Url from "../../../../../../Services/Url";

const AddContactFormOptions = (init, index = 0) => {
	console.log(init);
	const contract = init.contract || {};
	const { contactsInformationList = [{}], contractSign } = contract;
	const data = contactsInformationList[index] || {};
	const disabled = !!contractSign; // Disable if contractSign exists

	return {
		Extra: {
			id: data.id || null,
		},
		Fields: [
			{
				element: FormType.Input,
				required: false,
				label: "Authorized as",
				placeholder: "Authorized",
				value: data.authorizedAs,
				name: "authorizedAs",
				disabled: disabled,
			},
			[
				{
					element: FormType.Input,
					required: false,
					label: "Firstname",
					placeholder: "Enter firstname",
					value: data.firstname,
					name: "firstname",
					disabled: disabled,
				},
				{
					element: FormType.Input,
					required: false,
					label: "Lastname",
					placeholder: "Enter lastname",
					value: data.lastname,
					name: "lastname",
					disabled: disabled,
				},
			],
			[
				{
					element: FormType.Input,
					required: false,
					label: "Role",
					placeholder: "Enter role",
					value: data.role,
					name: "role",
					disabled: disabled,
				},
				{
					element: FormType.Input,
					required: false,
					label: "Job Title",
					placeholder: "Enter lastname",
					value: data.jobTitle,
					name: "jobTitle",
					disabled: disabled,
				},
			],
			{
				element: FormType.Select,
				required: false,
				label: "Company",
				placeholder: "Select company",
				options: { url: Url.company.all, id: "id", name: "name" },
				value: data.company,
				name: "company",
				disabled: disabled,
			},
			[
				{
					element: FormType.Input,
					required: false,
					label: "Email",
					placeholder: "Enter email",
					value: data.email,
					name: "email",
					disabled: disabled,
				},
				{
					element: FormType.Input,
					required: false,
					label: "Phone",
					placeholder: "Enter phone",
					value: data.phone,
					name: "phone",
					disabled: disabled,
				},
			],
			[
				{
					element: FormType.Input,
					required: false,
					label: "State / Province / Territory",
					placeholder: "Enter state",
					value: data.state,
					name: "state",
					disabled: disabled,
				},
				{
					element: FormType.Input,
					required: false,
					label: "Country",
					placeholder: "Select country",
					value: data.country,
					name: "country",
					disabled: disabled,
				},
			],
		],
	};
};

export default AddContactFormOptions;
